module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-select', {
    staticClass: "display-2 text-xs-center",
    staticStyle: {
      "color": "#000 !important"
    },
    attrs: {
      "items": _vm.themes,
      "item-text": "name",
      "item-value": "id",
      "solo": "",
      "background-color": "transparent",
      "flat": ""
    },
    on: {
      "change": _vm.goToTheme
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "d-flex justify-center",
          staticStyle: {
            "width": "100%"
          }
        }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])]
      }
    }]),
    model: {
      value: (_vm.currentTheme),
      callback: function($$v) {
        _vm.currentTheme = $$v
      },
      expression: "currentTheme"
    }
  }), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "margin-top": "1px",
      "background": "#fff",
      "border": "1px solid #ddd",
      "padding-left": "20px",
      "padding-right": "20px",
      "margin-left": "0px",
      "margin-right": "0px"
    },
    attrs: {
      "align-start": "",
      "justify-center": "",
      "row": "",
      "dashBoardHeader": ""
    }
  }, [(_vm.themeHeader !== 'Dashboard') ? _c('view-selector', {
    staticClass: "mt-3",
    attrs: {
      "bus": _vm.bus
    },
    on: {
      "view-changed": _vm.viewChanged
    }
  }) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.enableDateSelector === true) ? _c('date-range-selector', {
    attrs: {
      "date-range": _vm.dateRange,
      "bus": _vm.bus
    },
    on: {
      "dates-picked": _vm.submitDates
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.enableDateSelector === true) ? _c('v-spacer') : _vm._e(), _vm._v(" "), (_vm.viewType === 'date_range' && (_vm.themeHeader === 'Conversion' || _vm.themeHeader === 'Escalation')) ? _c('period-selector', {
    staticClass: "mt-3",
    on: {
      "period-changed": function($event) {
        return _vm.$emit('date-range-changed')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.viewType === 'date_range' && _vm.themeHeader === 'Fulfillment') ? _c('interval-selector', {
    staticClass: "mt-3",
    on: {
      "period-changed": function($event) {
        return _vm.$emit('date-range-changed')
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}